import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Link,
    TextField,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import sideImg from "../../assets/images/otp_page.jpg";
import { showToast } from "../Toast";
import { LoginApi } from "../../Sourcing/Services/User/Login";
import { useNavigate } from "react-router-dom";
import varifyOtpApi from "../../Sourcing/Services/User/VarifyOtp";
import loginbg from "../../assets/images/loginbg.png";
import bggif from "../../assets/images/bggif.gif";
import finalLogo from "../../assets/icons/Final_Logo.png";

// import "react-toastify/dist/ReactToastify.css";
export const Otp = ({ setIsLoggedIn }) => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
    const [timer, setTimer] = useState(120); // Timer in seconds
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    React.useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
            return () => clearInterval(interval); // Cleanup on component unmount or timer reset
        } else {
            setIsResendEnabled(true);
        }
    }, [timer]);

    const formatTimer = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        index: number
    ) => {
        const value = e.target.value;
        // Allow only numbers and limit to one character
        if (isNaN(Number(value)) || value.length > 1) return;
        const updatedOtp = [...otp];
        updatedOtp[index] = value;
        setOtp(updatedOtp);
        // Auto-focus next field
        if (value && index < otp.length - 1) {
            document.getElementById(`otp-input-${index + 1}`)?.focus();
        }
    };
    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement>,
        index: number
    ) => {
        const key = e.key;
        if (key === "Backspace") {
            e.preventDefault(); // Prevent default behavior
            const updatedOtp = [...otp];
            if (otp[index] === "") {
                // Move focus to the previous input field if empty
                if (index > 0) {
                    document.getElementById(`otp-input-${index - 1}`)?.focus();
                }
            } else {
                // Clear the current input
                updatedOtp[index] = "";
                setOtp(updatedOtp);
            }
        }
    };
    const handleResend = async () => {
        setOtp(new Array(6).fill(""));
        // setError(false);
        setTimer(120); // Reset the timer to 20 seconds
        setIsResendEnabled(false);
        let getEmailByLocalStorage = localStorage.getItem("email");
        let getResendMail = localStorage.getItem("sendEmail");
        if (getEmailByLocalStorage) {
            try {
                const login = await LoginApi({
                    email: getEmailByLocalStorage,
                    sendEmail: getResendMail,
                    resend: true
                });
                if (login?.status) {
                    showToast({
                        message: "OTP Sent successfully!",
                        type: "success"
                    });
                } else {
                    showToast({
                        message: login?.message,
                        type: "error"
                    });
                }
            } catch (error) {
                showToast({
                    message: "Something went to wrong",
                    type: "error"
                });
            }
        } else {
            navigate("/");
        }
    };
    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text");
        const pastedNumbers = pastedData.replace(/[^0-9]/g, ""); // Remove non-numeric characters
        if (pastedNumbers.length > otp.length) return; // Ignore if pasted data exceeds OTP length
        const updatedOtp = [...otp];
        for (let i = 0; i < pastedNumbers.length; i++) {
            updatedOtp[i] = pastedNumbers[i];
        }
        setOtp(updatedOtp);
        // Focus on the next empty input field after the pasted numbers
        const nextEmptyIndex = updatedOtp.findIndex((digit) => digit === "");
        if (nextEmptyIndex !== -1) {
            document.getElementById(`otp-input-${nextEmptyIndex}`)?.focus();
        }
    };

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        setIsSubmitted(true);

        e.preventDefault();
        const joinigOtp = otp?.join("");
        const getEmailByLocalStorage = localStorage.getItem("email");
        if (joinigOtp && getEmailByLocalStorage) {
            try {
                const varifyOtp = await varifyOtpApi({
                    email: getEmailByLocalStorage,
                    otp: Number(joinigOtp)
                });
                setIsSubmitted(false);
                if (varifyOtp?.status) {
                    localStorage.setItem("isLoggedIn", "true");
                    localStorage.setItem(
                        "manager_details",
                        JSON.stringify(varifyOtp?.data)
                    );

                    setIsLoggedIn(true); // Trigger re-render immediately
                    window.dispatchEvent(new Event("storage"));

                    showToast({
                        message: "OTP verified successfully!",
                        type: "success"
                    });
                    navigate("/layout/Dashboard");
                } else {
                    showToast({
                        message: varifyOtp?.message,
                        type: "error"
                    });
                }
            } catch (error) {
                setIsSubmitted(false);
                showToast({
                    message: "Something went to wrong",
                    type: "error"
                });
            }
        } else {
            navigate("/");
        }
    };

    useEffect(() => {
        let getEmailByLocalStorage = localStorage.getItem("email");
        if (!getEmailByLocalStorage) {
            navigate("/");
        }
    });

    return (
        <div
            style={{
                backgroundImage: `url(${bggif})`,
                height: "100vh",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                        "linear-gradient(0deg, rgb(4 37 65 / 92%) 0%, rgba(3, 51, 115, 0.53) 53%, rgb(4 37 65 / 92%) 100%)",
                    zIndex: 1
                }}
            />
            <Container
                style={{
                    alignItems: "center",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                {/* <ToastContainer /> */}
                <Box sx={{ flexGrow: 1, padding: "20px" }}>
                    <Grid
                        container
                        spacing={3}
                        style={{
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5 }}>
                            <div
                                style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 5,
                                    background: "#fff",
                                    position: "relative",
                                    padding: "40px 20px",
                                    borderRadius: "16px",
                                    textAlign: "center"
                                }}
                            >
                                <img src={finalLogo} width={"115px"} />

                                <Typography
                                    variant="h5"
                                    fontWeight={600}
                                    mb={1}
                                    mt={2}
                                >
                                    Enter Verification Code
                                </Typography>
                                <form>
                                    <Grid
                                        spacing={3}
                                        style={{ display: "flex" }}
                                    >
                                        {otp.map((digit, index) => (
                                            <TextField
                                                id={`otp-input-${index}`}
                                                value={digit}
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                ) => handleChange(e, index)}
                                                inputProps={{
                                                    maxLength: 1,
                                                    style: {
                                                        textAlign: "center",
                                                        width: "35px"
                                                    }
                                                }}
                                                variant="outlined"
                                                onKeyDown={(
                                                    e: React.KeyboardEvent<HTMLInputElement>
                                                ) => handleKeyDown(e, index)}
                                                onPaste={handlePaste}
                                                type="text"
                                                sx={{
                                                    "& .MuiOutlinedInput-root":
                                                        {
                                                            marginRight: "10px",
                                                            marginY: "10px"
                                                        }
                                                }}
                                            />
                                        ))}
                                    </Grid>
                                    <Typography
                                        sx={{
                                            color: "text.secondary",
                                            display: "flex",
                                            justifyContent: "space-between"
                                        }}
                                        variant="body2"
                                        my="10px"
                                    >
                                        We sent a verification code to your
                                        email
                                        <Link
                                            onClick={
                                                isResendEnabled
                                                    ? handleResend
                                                    : undefined
                                            }
                                            sx={{
                                                pointerEvents: isResendEnabled
                                                    ? "auto"
                                                    : "none",
                                                textDecoration: isResendEnabled
                                                    ? "auto"
                                                    : "none",
                                                cursor: isResendEnabled
                                                    ? "pointer"
                                                    : "not-allowed"
                                            }}
                                        >
                                            {isResendEnabled
                                                ? `Resend OTP`
                                                : `Timer: ${formatTimer(timer)}`}
                                        </Link>
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: "text.secondary",
                                            textAlign: "left"
                                        }}
                                        variant="body2"
                                    >
                                        By continuing, you agree that we create
                                        an account for you, and accept our Terms
                                        and Conditions and Privacy Policy.
                                    </Typography>
                                    <Button
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        style={{ marginTop: "20px" }}
                                        disabled={
                                            !otp.every(
                                                (value) => value.trim() !== ""
                                            ) || isSubmitted
                                        }
                                        onClick={handleSubmit}
                                    >
                                        Continue
                                    </Button>
                                </form>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </div>
    );
};
